import { render, staticRenderFns } from "./RealFriendMeetingPage.vue?vue&type=template&id=ff923294&scoped=true"
import script from "./RealFriendMeetingPage.vue?vue&type=script&lang=js"
export * from "./RealFriendMeetingPage.vue?vue&type=script&lang=js"
import style0 from "./RealFriendMeetingPage.vue?vue&type=style&index=0&id=ff923294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff923294",
  null
  
)

export default component.exports